// @flow
import React, { Fragment } from 'react'
import { translations, translateFunc } from '../../shared/localize'
import { HeaderCell, HeaderRow } from '../MainTable'

const t = translateFunc(translations.provider_publics.thead)

export default function Thead() {
  return (
    <Fragment>
      <colgroup>
        <col width="70%" />
        <col width="30%" />
      </colgroup>
      <thead>
        <HeaderRow>
          <HeaderCell alignLeft>{t('label')}</HeaderCell>
          <HeaderCell alignLeft>{t('ads_access')}</HeaderCell>
        </HeaderRow>
      </thead>
    </Fragment>
  )
}
